module.exports = false;


/*****************
 ** WEBPACK FOOTER
 ** /Users/msolazzi/works/menichetti/~/core-js/modules/_library.js
 ** module id = 46
 ** module chunks = 0
 **/